// ADR-0156 (#0754) — la marca del aviso inmediato por observación crítica
// en el dashboard: «Avisada al jefe 10:42» en la lista del proyecto y en
// el detalle. Lógica pura, sin DOM ni red. Ningún literal de criticidad:
// el pill lo pinta `SevPill` desde `CRITICIDAD_LABEL`.

import type { CriticalAlertMark } from "@bitacorapro/api-types";

const HORA_SANTIAGO = new Intl.DateTimeFormat("es-CL", {
  timeZone: "America/Santiago",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

/** «HH:MM» de pared en Santiago. */
function horaSantiago(iso: string): string | null {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : HORA_SANTIAGO.format(d);
}

/** El texto de la marca, o null si la observación no tuvo aviso. Un aviso
 *  que salió a los gerentes (el proyecto sin jefe válido) no se presenta
 *  como avisado al jefe. «No pudimos avisar» queda para un envío que
 *  falló: no haber a quién avisar, que lo registrara el único a quien
 *  se le avisaría, o que la registrara el jefe del proyecto (entonces no
 *  se avisa a nadie), se dicen como son. */
export function avisoCriticoLabel(mark: CriticalAlertMark | null | undefined): string | null {
  if (!mark) return null;
  if (mark.status === "failed") return "No pudimos avisar al jefe";
  if (mark.status === "unknown") return "Aviso al jefe sin confirmar";
  if (mark.status === "no_recipient") return "Sin aviso: el proyecto no tiene a quién avisar";
  if (mark.status === "author_is_recipient") return "Sin aviso: la registró quien lo recibiría";
  if (mark.status === "author_is_jefe") return "Registrada por el jefe del proyecto";
  const hora = mark.at ? horaSantiago(mark.at) : null;
  const base = mark.recipientKind === "gerentes" ? "Avisada a los gerentes" : "Avisada al jefe";
  return hora ? `${base} ${hora}` : base;
}
